import { normalizeTablerIconName } from "@/shared/ui/icon-picker/tabler-icon-core";
import { getTablerIconLabel, isKnownTablerIconName } from "@/shared/ui/icon-picker/tabler-icon-registry";

export type WorkObjectTypeIcon = string;

export function isWorkObjectTypeIcon(icon: string): icon is WorkObjectTypeIcon {
  return isKnownTablerIconName(icon);
}

export function normalizeWorkObjectTypeIcon(icon: string) {
  return normalizeTablerIconName(icon);
}

export function getWorkObjectTypeIconLabel(icon: string) {
  return getTablerIconLabel(icon);
}
